export { ChronologyVariation as default } from './ChronologyVariation';
